var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-xs"},[_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.label)+" ")]),(_vm.required)?_c('span',{staticClass:"has-text-danger"},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }